exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#post-block-wrapper .w-fan-page {\n  margin-top: 40px;\n}", ""]);

// exports
